import { createSlice } from "@reduxjs/toolkit";
import {
  creatCashFlow,
  deleteCashflowParams,
  getCashFlowResult,
  getIndividualCashflowParam,
  updateCashFlow,
} from "./cashFlowActions";
import { first } from "lodash";

export const initialState = {
  isInitialLoad: true,
  loading: false,
  addLoading: false,
  cashflow: {},
  assetIntialLoad: true,
  assets: {},
  addAssetLoading: false,
  cashflowResult: {},
  paramsLoader: false,
  selectedCashflowParams: {},
  individualCashflowParam: [],
};

const cashFlowSlice = createSlice({
  name: "cashflow",
  initialState,
  reducers: {
    setInitialLoad: (state, action) => {
      state.isInitialLoad = action.payload;
    },
    setAssetInitialLoad: (state, action) => {
      state.assetIntialLoad = action.payload;
    },
    setSelectedCashflowParams: (state, action) => {
      state.selectedCashflowParams = action.payload;
    },
    clearProjectData: (state) => {
      state.initialState = true;
      state.loading = false;
      state.addLoading = false;
      state.cashflowResult = {};
      state.assetIntialLoad = true;
      state.assets = {};
      state.addAssetLoading = false;
      state.paramsLoader = false;
    },
    refreshCashflow: (state) => {
      state.initialState = true;
      state.loading = false;
      state.addLoading = false;
      state.cashflowResult = {};
      state.paramsLoader = false;
      state.selectedCashflowParams = {};
      state.individualCashflowParam = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // cash flow Result
      .addCase(getCashFlowResult.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCashFlowResult.fulfilled, (state, action) => {
        state.loading = false;
        state.isInitialLoad = false;
        state.cashflowResult = action.payload?.data;
      })
      .addCase(getCashFlowResult.rejected, (state) => {
        state.loading = false;
        state.isInitialLoad = false;
        state.cashflowResult = {};
      })
      // add new cash flow
      .addCase(creatCashFlow.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(creatCashFlow.fulfilled, (state, action) => {
        state.addLoading = false;
      })
      .addCase(creatCashFlow.rejected, (state, action) => {
        state.addLoading = false;
      })
      // get cash flow INDIVIDUAL CASHFLOW PARAM
      .addCase(getIndividualCashflowParam.pending, (state) => {
        state.loading = true;
        state.selectedCashflowParams = {};
        state.individualCashflowParam = [];
      })
      .addCase(getIndividualCashflowParam.fulfilled, (state, action) => {
        state.loading = false;
        state.isInitialLoad = false;
        const data = action.payload?.data;
        state.individualCashflowParam = data
          ? Array.isArray(data)
            ? data
            : [data]
          : {};
        state.selectedCashflowParams = data
          ? Array.isArray(data)
            ? first(data)
            : data
          : {};
      })
      .addCase(getIndividualCashflowParam.rejected, (state) => {
        state.loading = false;
        state.isInitialLoad = false;
        state.selectedCashflowParams = {};
        state.individualCashflowParam = [];
      })

      // update cash Flow
      .addCase(updateCashFlow.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateCashFlow.fulfilled, (state, action) => {
        state.addLoading = false;
      })
      .addCase(updateCashFlow.rejected, (state, action) => {
        state.addLoading = false;
      })
      // delete cashflow params
      .addCase(deleteCashflowParams.pending, (state) => {
        state.paramsLoader = true;
      })
      .addCase(deleteCashflowParams.fulfilled, (state, action) => {
        state.paramsLoader = false;
      })
      .addCase(deleteCashflowParams.rejected, (state, action) => {
        state.paramsLoader = false;
      });
  },
});

export const {
  setInitialLoad,
  setRoleInitalLoad,
  setAssetInitialLoad,
  clearProjectData,
  refreshCashflow,
  setSelectedCashflowParams,
} = cashFlowSlice.actions;
export default cashFlowSlice.reducer;
